import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch } = FiIcons;

const SearchBar = ({ value, onChange, onSearch }) => {
  const [localValue, setLocalValue] = useState(value);

  const handleSubmit = (e) => {
    e.preventDefault();
    onChange(localValue);
    onSearch();
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    // Auto-search after a delay
    if (newValue === '') {
      onChange('');
      onSearch();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="relative">
      <div className="relative">
        <SafeIcon 
          icon={FiSearch} 
          className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" 
        />
        <input
          type="text"
          value={localValue}
          onChange={handleInputChange}
          placeholder="Search by title or author..."
          className="w-full pl-12 pr-4 py-4 text-lg bg-white rounded-2xl border-2 border-gray-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 transition-all duration-300 shadow-lg"
        />
      </div>
      <motion.button
        type="submit"
        className="absolute right-2 top-1/2 transform -translate-y-1/2 px-6 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all duration-300"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Search
      </motion.button>
    </form>
  );
};

export default SearchBar;